<div class="options-container" [class.inactive]="activeTableLocked" [class.hidden]="optionsActive | equals:false">
    <div class="menu-btn-container">
        <div class="menu-btn-backer">
            <i class="fas fa-bars menu-btn" (click)="_openSideMenu($event)"></i>
        </div>
    </div>
    <main-menu-bar-options *ngIf="displayMainOptions" (insertLine)="_onInsertLine.emit($event)" (insertMultiLines)="_onInsertMultiLine.emit($event)" (delete)="_onDeleteSelection.emit($event)"></main-menu-bar-options>
    <version-dropdown></version-dropdown>
</div>